import { z } from 'zod';

import { AddressZod } from 'types/zod/address';

export const AddressWithNameZod = z.object({
    address: AddressZod,
    name: z.string(),
});

export type AddressWithName = z.infer<typeof AddressWithNameZod>;
